<template>
  <ui-modal-layout
    :title="title"
    :description="tr('Please, enter you 6-digit authentication code from the Google Authenticator app.')"
    :icon="ShieldCheckIcon"
    :tone="destructive ? 'destructive' : 'primary'"
  >
    <auth-code-input
      ref="authCodeInput"
      v-model="code"
      :disabled="isLoading"
      class="justify-center"
      @enter="() => submit()"
    />
    <label v-if="trustOption" class="flex cursor-pointer items-center justify-center gap-2.5 text-sm text-foreground">
      <ui-checkbox v-model="trust" />
      {{ tr('Trust this device for 30 days') }}
    </label>

    <template #footer>
      <ui-button variant="outline" @click="() => cancel()">
        {{ tr(cancelButtonLabel) }}
      </ui-button>
      <ui-button :variant="destructive ? 'destructive' : 'default'" :disabled="isLoading" @click="() => submit()">
        <loader-circle-icon v-if="isLoading" class="animate-spin" />
        {{ tr('Confirm') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { LoaderCircle, ShieldCheck } from '@lucide/vue';
import { markRaw } from 'vue';

import AuthCodeInput from '@/ui/components/AuthCodeInput.vue';

export default {
  name: 'Google2faCodeForm',
  components: {
    AuthCodeInput,
    LoaderCircleIcon: LoaderCircle,
  },
  props: {
    modelValue: {
      type: String,
      required: false,
      default: () => '',
    },
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    // Red confirm button (e.g. turning 2FA off).
    destructive: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    cancelButtonLabel: {
      type: String,
      required: false,
      default: () => 'Cancel',
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    trustOption: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue', 'submit', 'cancel' ],
  data: () => ({
    ShieldCheckIcon: markRaw(ShieldCheck),
    code: '',
    trust: false,
  }),
  watch: {
    modelValue(value) {
      this.code = value ?? '';
    },
    code() {
      this.$emit('update:modelValue', this.code);
    },
  },
  mounted() {
    this.$nextTick(() => this.$refs['authCodeInput'].focus());
  },
  methods: {
    submit() {
      if (this.code.length !== 6) {
        this.error(this.tr('You must enter the 6-digit code from the Google Authenticator app.'));
        return;
      }
      if (this.isLoading) {
        return;
      }

      this.$emit('submit', { trust: this.trust });
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
